var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"copyright"},[_c('span',[_c('a',{attrs:{"href":"http://www.beian.miit.gov.cn/","target":"_blank"}},[_vm._v(_vm._s(_vm.beian))])]),_c('span',[_vm._v("由 www.zoosoft.cn 提供技术支持. Ver:"+_vm._s(_vm.ver)+" Build:"+_vm._s(_vm.build))])])
}
var staticRenderFns = []

export { render, staticRenderFns }